import axios from 'axios';
import { IShelfDivider } from 'src/infrastructure/interfaces';

export default class ShelfDividerService {

    static editShelfDivider(divider: IShelfDivider, formData: FormData) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/shelfseparator/${divider.id}`,
                    formData,
                    { headers: {'Content-Type': 'multipart/form-data' }})
                .then((res) => {
                    resolve(res.data);
                })
                .catch(error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/ShelfDividerService.ts